var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgT(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 51,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.153.6c.624 0 1.128.192 1.512.576.432.384.648.888.648 1.512s-.216 1.128-.648 1.512c-.384.336-.888.504-1.512.504H22.25V48.84c0 .624-.216 1.152-.648 1.584-.432.384-.96.576-1.584.576-.672 0-1.224-.192-1.656-.576-.384-.432-.576-.96-.576-1.584V4.704H2.881c-.624 0-1.152-.192-1.584-.576C.913 3.744.721 3.24.721 2.616c0-.576.192-1.056.576-1.44C1.73.792 2.257.6 2.881.6h34.272z",
    fill: "currentColor"
  })));
}
export default SvgT;